import React, {Component} from 'react';
import { Container, Image } from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import { withRouter } from 'react-router-dom';

import AboutStore from '../../components/setup/AboutStore';
import Welcome from '../../components/setup/Welcome';

const logo = require('../../img/logo_text1.svg');

class AccountSetup extends Component {

  constructor() {
    super();

    this.nextAboutStore = this.nextAboutStore.bind(this);
    this.backAboutYou = this.backAboutYou.bind(this);
    this.finish = this.finish.bind(this);
    this.end = this.end.bind(this);
  }

  nextAboutStore(){
    this.refs.aboutYou.open();
  }

  finish(){
    this.refs.welcome.open();
  }

  backAboutYou(){
    this.refs.aboutStore.open();
  }

  end(){
    this.props.history.push('/');
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Configuración de tu cuenta - Quipuu</title>
        </Helmet>
        <Container style={{'marginTop':50,}}>
          <Image centered src={logo} height={45} alt='logo' />
          <AboutStore ref='aboutStore' finish={this.finish} />
          <Welcome ref='welcome' finish={this.end} />
        </Container>
      </div>
    );
  }
}

export default withRouter(AccountSetup);



// WEBPACK FOOTER //
// ./src/containers/setup/AccountSetup.js